import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function (element, data) {
    gsap.to(".viruses-item-1", {
        y: -50,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: element,
            start: "top center=-25%",
            end: "bottom top",
            scrub: 1.0
        }
    });

    gsap.to(".viruses-item-2", {
        y: -45,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: element,
            start: "top center=-25%",
            end: "bottom top",
            scrub: 1.1
        }
    });

    gsap.to(".viruses-item-3", {
        y: -35,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: element,
            start: "top center=-25%",
            end: "bottom top",
            scrub: 1.15
        }
    });

    gsap.to(".viruses-item-4", {
        y: -25,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: element,
            start: "top center=-25%",
            end: "bottom top",
            scrub: 1.3
        }
    });

    gsap.to(".viruses-item-5", {
        y: -25,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: element,
            start: "top center=-25%",
            end: "bottom top",
            scrub: 1.3
        }
    });
}
